import { memo } from 'react';

const LiftGateOverride = (props) => {
  const { color = '#666666', size = 15 } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7749 7.25C11.7749 4.49001 14.0149 2.25 16.7749 2.25C19.5349 2.25 21.7749 4.49001 21.7749 7.25C21.7749 10.01 19.5349 12.25 16.7749 12.25C14.0149 12.25 11.7749 10.01 11.7749 7.25ZM16.2749 9.25V10.25H17.2749V9.25H16.2749ZM16.2749 4.25V8.25H17.2749V4.25H16.2749ZM8.07538 4.75L9.91388 5.85527C9.82275 6.306 9.7749 6.77241 9.7749 7.25C9.7749 8.29114 10.0022 9.27919 10.4099 10.1672L7.29022 12.2156L10.6945 14.4966L12.8759 13.0644C13.4755 13.4673 14.1407 13.7798 14.8523 13.9826L12.3961 15.6435L17.5614 19.1234C17.6432 19.1785 17.6042 19.3063 17.5055 19.3063H13.7523L10.7251 17.2138L7.61707 19.3063H4.10736C4.00989 19.3063 3.97003 19.1811 4.04956 19.1247L8.96454 15.6435L4.98755 13.0375C4.24384 12.6125 4.24384 11.55 4.98755 11.125L9.45007 8.15002L4.34851 4.9346C4.26373 4.88113 4.30157 4.75 4.40186 4.75H8.07538ZM2.86261 21.75H18.5877C18.9064 21.75 19.2252 21.2756 19.2252 20.819C19.2252 20.3624 18.9064 19.888 18.5877 19.888H2.86261C2.54382 19.888 2.2251 20.2805 2.2251 20.819C2.2251 21.3575 2.54382 21.75 2.86261 21.75Z"
        fill={color}
      />
    </svg>
  );
};

export default memo(LiftGateOverride);
